/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseClient } from '../base-client';
import { DmsApiConfiguration } from '../dms-api-configuration';
import { DmsResponse } from '../dms-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DmsDocumentModel } from '../models/dms-document-model';
import { DmsDocumentQuery } from '../models/dms-document-query';
import { DmsPatchDocumentRequest } from '../models/dms-patch-document-request';
import { DmsSaveDocumentRequest } from '../models/dms-save-document-request';
import { DmsUpdateDocumentRequest } from '../models/dms-update-document-request';

@Injectable({
  providedIn: 'root',
})
export class DmsDocumentsClient extends BaseClient {
  constructor(
    config: DmsApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createDocument
   */
  static readonly CreateDocumentPath = '/api/Documents/{fullPath}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDocument()` instead.
   *
   * This method sends `multipart/form-data` and handles response body of type `multipart/form-data`
   */
  createDocument$Response(params: {
    fullPath: string;

    body?: DmsSaveDocumentRequest
  }): Observable<DmsResponse<DmsDocumentModel>> {

    const rb = new RequestBuilder(this.rootUrl, DmsDocumentsClient.CreateDocumentPath, 'post');
    if (params) {

      rb.path('fullPath', params.fullPath);

      rb.body(params.body, 'multipart/form-data');
    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as DmsResponse<DmsDocumentModel>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createDocument$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles response body of type `multipart/form-data`
   */
  createDocument(params: {
    fullPath: string;

    body?: DmsSaveDocumentRequest
  }): Observable<DmsDocumentModel> {

    return this.createDocument$Response(params).pipe(
      map((r: DmsResponse<DmsDocumentModel>) => r.body as DmsDocumentModel)
    );
  }

  /**
   * Path part for operation getDocuments
   */
  static readonly GetDocumentsPath = '/api/Documents/query/{pathFilter}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDocuments()` instead.
   *
   * This method sends `application/json` and handles response body of type `application/json`
   */
  getDocuments$Response(params: {
    pathFilter: string;

    body?: DmsDocumentQuery
  }): Observable<DmsResponse<Array<DmsDocumentModel>>> {

    const rb = new RequestBuilder(this.rootUrl, DmsDocumentsClient.GetDocumentsPath, 'post');
    if (params) {

      rb.path('pathFilter', params.pathFilter);

      rb.body(params.body, 'application/json');
    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as DmsResponse<Array<DmsDocumentModel>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDocuments$Response()` instead.
   *
   * This method sends `application/json` and handles response body of type `application/json`
   */
  getDocuments(params: {
    pathFilter: string;

    body?: DmsDocumentQuery
  }): Observable<Array<DmsDocumentModel>> {

    return this.getDocuments$Response(params).pipe(
      map((r: DmsResponse<Array<DmsDocumentModel>>) => r.body as Array<DmsDocumentModel>)
    );
  }

  /**
   * Path part for operation getDocument
   */
  static readonly GetDocumentPath = '/api/Documents/{documentId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDocument()` instead.
   *
   * This method doesn't expect any response body
   */
  getDocument$Response(params: {
    documentId: number;

  }): Observable<DmsResponse<DmsDocumentModel>> {

    const rb = new RequestBuilder(this.rootUrl, DmsDocumentsClient.GetDocumentPath, 'get');
    if (params) {

      rb.path('documentId', params.documentId);

    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as DmsResponse<DmsDocumentModel>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDocument$Response()` instead.
   *
   * This method doesn't expect any response body
   */
  getDocument(params: {
    documentId: number;

  }): Observable<DmsDocumentModel> {

    return this.getDocument$Response(params).pipe(
      map((r: DmsResponse<DmsDocumentModel>) => r.body as DmsDocumentModel)
    );
  }

  /**
   * Path part for operation updateDocument
   */
  static readonly UpdateDocumentPath = '/api/Documents/{documentId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDocument()` instead.
   *
   * This method sends `multipart/form-data` and handles response body of type `multipart/form-data`
   */
  updateDocument$Response(params: {
    documentId: number;

    body?: DmsUpdateDocumentRequest
  }): Observable<DmsResponse<DmsDocumentModel>> {

    const rb = new RequestBuilder(this.rootUrl, DmsDocumentsClient.UpdateDocumentPath, 'put');
    if (params) {

      rb.path('documentId', params.documentId);

      rb.body(params.body, 'multipart/form-data');
    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as DmsResponse<DmsDocumentModel>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateDocument$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles response body of type `multipart/form-data`
   */
  updateDocument(params: {
    documentId: number;

    body?: DmsUpdateDocumentRequest
  }): Observable<DmsDocumentModel> {

    return this.updateDocument$Response(params).pipe(
      map((r: DmsResponse<DmsDocumentModel>) => r.body as DmsDocumentModel)
    );
  }

  /**
   * Path part for operation deleteDocument
   */
  static readonly DeleteDocumentPath = '/api/Documents/{documentId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteDocument()` instead.
   *
   * This method doesn't expect any response body
   */
  deleteDocument$Response(params: {
    documentId: number;

  }): Observable<DmsResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DmsDocumentsClient.DeleteDocumentPath, 'delete');
    if (params) {

      rb.path('documentId', params.documentId);

    }
    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as DmsResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteDocument$Response()` instead.
   *
   * This method doesn't expect any response body
   */
  deleteDocument(params: {
    documentId: number;

  }): Observable<void> {

    return this.deleteDocument$Response(params).pipe(
      map((r: DmsResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation patchDocument
   */
  static readonly PatchDocumentPath = '/api/Documents/{documentId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchDocument()` instead.
   *
   * This method sends `application/json` and handles response body of type `application/json`
   */
  patchDocument$Response(params: {
    documentId: number;

    body?: DmsPatchDocumentRequest
  }): Observable<DmsResponse<DmsDocumentModel>> {

    const rb = new RequestBuilder(this.rootUrl, DmsDocumentsClient.PatchDocumentPath, 'patch');
    if (params) {

      rb.path('documentId', params.documentId);

      rb.body(params.body, 'application/json');
    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as DmsResponse<DmsDocumentModel>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `patchDocument$Response()` instead.
   *
   * This method sends `application/json` and handles response body of type `application/json`
   */
  patchDocument(params: {
    documentId: number;

    body?: DmsPatchDocumentRequest
  }): Observable<DmsDocumentModel> {

    return this.patchDocument$Response(params).pipe(
      map((r: DmsResponse<DmsDocumentModel>) => r.body as DmsDocumentModel)
    );
  }

  /**
   * Path part for operation deleteDocumentsWithPath
   */
  static readonly DeleteDocumentsWithPathPath = '/api/Documents/{pathFilter}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteDocumentsWithPath()` instead.
   *
   * This method doesn't expect any response body
   */
  deleteDocumentsWithPath$Response(params: {
    pathFilter: string;

  }): Observable<DmsResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DmsDocumentsClient.DeleteDocumentsWithPathPath, 'delete');
    if (params) {

      rb.path('pathFilter', params.pathFilter);

    }
    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as DmsResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteDocumentsWithPath$Response()` instead.
   *
   * This method doesn't expect any response body
   */
  deleteDocumentsWithPath(params: {
    pathFilter: string;

  }): Observable<void> {

    return this.deleteDocumentsWithPath$Response(params).pipe(
      map((r: DmsResponse<void>) => r.body as void)
    );
  }

}
